import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-managepage',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './managepage.component.html',
  styleUrls: ['./managepage.component.scss']
})
export class ManagepageComponent implements OnInit {

  @Input() commonemit
  
  constructor() { }

  ngOnInit() {
  }

}
